<template>
    <section>
        <ul class="file-info-tabs nav nav-pills p-2 px-3 mx-auto bg-gray-lighter" role="tablist">
            <li class="nav-item">
                <a class="nav-link" :class="{ 'active': current_view == 'info' }" data-toggle="tab"
                    href="#" @click.prevent="current_view = 'info'" role="tab" :aria-expanded="current_view == 'info'">Info</a>
            </li>
            <li class="nav-item" v-if="!hide_versions && !is_folder">
                <a class="nav-link" :class="{ 'active': current_view == 'versions' }" data-toggle="tab"
                    href="#" @click.prevent="current_view = 'versions'"
                    role="tab" :aria-expanded="current_view == 'versions'">Versions<small v-if="versions_num !== null"> ({{ versions_num }})</small></a>
            </li>
            <li class="nav-item" v-if="!hide_shares">
                <a class="nav-link" :class="{ 'active': current_view == 'shares' }" data-toggle="tab"
                    href="#" @click.prevent="current_view = 'shares'" role="tab"
                    :aria-expanded="current_view == 'shares'">Shares<small v-if="shares_num !== null"> ({{ shares_num }})</small></a>
            </li>
        </ul>

        <div class="tab-content mt-4">

            <!-- Info tab -->
            <div class="tab-pane" :class="{ 'show active': current_view == 'info' }" role="tabpanel">
                <table class="table mx-auto fileinfo">
                    <tbody>
                        <tr>
                            <th>Name</th>
                            <td>{{ file.name }}</td>
                        </tr>
                        <tr v-if="!is_folder">
                            <th>Size</th>
                            <td>{{ file.size | format_bytes }} <small>({{ Number(file.size).toLocaleString() }} bytes)</small></td>
                        </tr>
                        <tr>
                            <th>Type</th>
                            <td>{{ is_folder ? 'FOLDER' : file.mime_type }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Versions tab -->
            <div v-if="!hide_versions && !is_folder" class="tab-pane" :class="{ 'show active': current_view == 'versions' }" role="tabpanel">
                <file-versions-table 
                    :file="file" 
                    :user="user"
                    :disable_download="disable_download"
                    :modifiedBoxExternal="file_version_external_user"
                    :force_narrow="force_narrow"
                    @versions_num="(updated_versions_num) => { versions_num = updated_versions_num }"
                    @close="$emit('close')"
                    />
            </div>

            <!-- Shares tab -->
            <div v-if="!hide_shares" class="tab-pane " :class="{ 'show active': current_view == 'shares' }" role="tabpanel">
                <file-sharing-status 
                    :user="user" 
                    :file="file"
                    @shares_num="(updated_shares_num) => { shares_num = updated_shares_num }"
                    @close="$emit('close')"
                />
            </div>

        </div>
    </section>
</template>
<script lang="js">

import fileVersionsTable from './file-versions-table.vue';
import fileSharingStatus from './file-sharing-status.vue';
import { NamespaceService } from '@/services/namespace-service';
import { Utils } from '@/helpers/utils';

export default {

    components: {
        fileVersionsTable,
        fileSharingStatus
    },

    props: {

        // The file/folder whose details are displayed.
        file: Object,

        // The logged-in user, its 'team_settings' and 'team' fields are used
        user: Object,

        // Which view to start on, 'info' (default), 'versions' or 'shares'
        view: {
            type: String,
            default: 'info'
        },

        // When set to true, the Versions tab is hidden
        hide_versions: {
            type: Boolean,
            default: false
        },

        // When set to true, the Shares tab is hidden
        hide_shares: {
            type: Boolean,
            default: false
        },
        
        // When set to True, versions and shares are displayed with their mobile-friendly narrow layout, 
        // regardless of the window width (e.g., in a modal)
        force_narrow: {
            type: Boolean,
            default: false
        },

        // External user to display as the file version creator when file.user_id is zero or negative
        file_version_external_user: [Object, null],

        // When set to True, downloading and previewing file versions is disabled
        disable_download: {
            type: Boolean,
            default: false
        }
    },

    data(){
        return {
            current_view: 'info',
            versions_num: null,
            shares_num: null,
        }
    },

    computed: {
        is_folder(){
            return this.file?.entity_type == NamespaceService.ENTITY_TYPE_FOLDER
        }
    },

    mounted(){
        // Set the initial view
        this.current_view = this.view
    },

    methods: {
        to_clipboard(str){
            return Utils.to_clipboard(str)
        }
    }
}
</script>
<style lang="css" scoped>

table.fileinfo{
    width: fit-content;
}

table.fileinfo th{
    text-align: right;
}

.file-info-tabs{
    width: fit-content;
    border-radius: .25rem;
}
.theme-dark .file-info-tabs,
.theme-ironshard .file-info-tabs{
    background-color: transparent !important;
    color: white !important
}

.nav-link{ 
    color: inherit; 
    padding: .5em 1.5em; 
}
.nav-link.active{
    color: white;
    background: linear-gradient(135deg, #009688 0, #42A5F5 100%)
}
</style>